import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#EDA211",
    },
    secondary: {
      main: "#D5CBFF",
    },
  },
});

export default theme;
